import React from 'react';
import { RecommendationBar } from '../../../components/Shared';
import { AdvertisementCiting } from '../../../components/citing/AdvertisementCiting';
import { NEWSPAPER_PUBINFO_SECTION_FIELDS } from '../constants/fieldList/newspaper';
import { PubMainTypeEnum } from '../../../types';
import GenericSection from '../../../components/GenericSection';
import { MoreOptionsSection } from '../../../components/MoreOptions';
import { TabHeaders } from '../constants';
var Newspaper = function Newspaper() {
  var NEWSPAPER_SECTION_TITLE_TEST_ID = 'newspaper-pub-section-test-id';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RecommendationBar, null), /*#__PURE__*/React.createElement(AdvertisementCiting, null), /*#__PURE__*/React.createElement(GenericSection, {
    name: PubMainTypeEnum.PUB_NEWSPAPER,
    sectionTitle: "Newspaper publication info",
    fieldList: NEWSPAPER_PUBINFO_SECTION_FIELDS,
    "data-test": NEWSPAPER_SECTION_TITLE_TEST_ID,
    selectedTab: TabHeaders.NEWSPAPER
  }), /*#__PURE__*/React.createElement(MoreOptionsSection, null));
};
export default Newspaper;